<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Ads'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Ads',
            actions: []
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'campuses',
                    width: '150px',
                    filterFieldName: 'campuses.name',
                    sortable: false,
                    filter: 'joinTable'
                },
                { value: 'adPosition.name', width: '150px' },
                { value: 'views', width: '150px' },
                { value: 'clicks', width: '150px' },
                { value: 'exposure', width: '150px' },
                { value: 'createdAt', width: '150px', filter: 'formatDate' }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'ads/index',
            deleteItem: 'ads/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/ads/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/ads/add');
        }
    }
};
</script>
